import React from 'react';
import { Link } from 'react-router-dom';
import { Container, Typography } from 'amphitheatre';
import { FaChevronLeft } from 'react-icons/fa';

import { Content, ReturnButton } from './UpdatePage.styled';

const { Header } = Typography;

interface Props {
  children?: React.ReactNode;
  title: string;
}

const UpdatePage: React.FunctionComponent<Props> = ({
  children,
  title,
}: Props) => {
  return (
    <div id="update-container">
      <Container className="content-container" size="lg">
        <Link to="/updates">
          <ReturnButton>
            <div className="icon">
              <FaChevronLeft />
            </div>
            Return Home
          </ReturnButton>
        </Link>
        <Header>{title}</Header>
        <Content>{children}</Content>
      </Container>
    </div>
  );
};

export default UpdatePage;
